import * as React from 'react';

// @ts-expect-error
import capitalize from 'underscore.string/capitalize';

import {Button} from 'shells/button/button';
import {Card} from 'shells/card/card';
import {CardIcon} from 'shells/icon/svg/card-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {Body} from 'shells/typography/body';
import {UppercaseLabel} from 'shells/typography/uppercase-label';

import type {
    BillingInfo_cardInfo as CardInfo,
    BillingInfo_bankInfo as BankInfo,
} from 'nutshell-graphql-types';

import styles from './payment-info.module.css';

type Props = {
    cardInfo: CardInfo | null | undefined;
    bankInfo: BankInfo | null | undefined;
    onEdit?: () => void;
    isLoading?: boolean;
};

export function PaymentInfo(props: Props) {
    const {cardInfo, bankInfo} = props;
    if (!cardInfo && !bankInfo) {
        return null;
    }

    const wrapperStyle = props.onEdit ? styles['wrapper--editable'] : undefined;

    return (
        <StackLegacy spacing={4}>
            <UppercaseLabel>Payment method</UppercaseLabel>
            <Card hasBorder={true}>
                <div className='flex justify-sb pad-16'>
                    {props.isLoading ? (
                        <LoadingPage padding={0} size={30} />
                    ) : (
                        <>
                            <div className={wrapperStyle}>
                                {cardInfo && (
                                    <div className={styles.container}>
                                        <div className='flex gap-8'>
                                            <CardIcon size={18} />
                                            <Body as='div' size='small'>
                                                **** {cardInfo.lastFourDigits}
                                            </Body>
                                        </div>
                                        <div className='flex gap-8'>
                                            <Body as='div' size='small'>
                                                {cardInfo.expirationMonth}/{cardInfo.expirationYear}
                                            </Body>
                                            <Body as='div' size='small'>
                                                ***
                                            </Body>
                                        </div>
                                    </div>
                                )}
                                {bankInfo && (
                                    <div className='flex gap-8'>
                                        <Body as='div' size='small'>
                                            {capitalize(bankInfo.accountType)} account
                                        </Body>
                                        <Body as='div' size='small'>
                                            ******
                                            {bankInfo.accountNumber}
                                        </Body>
                                    </div>
                                )}
                            </div>
                            {props.onEdit && (
                                <Button
                                    variant='text-primary'
                                    noPadding={true}
                                    onClick={props.onEdit}
                                >
                                    Edit
                                </Button>
                            )}
                        </>
                    )}
                </div>
            </Card>
        </StackLegacy>
    );
}
